import React from "react";
import {connect} from "react-redux";
import Table from "../../../common/components/Table/Table";
import PropTypes from "prop-types";
import {Checkbox} from "semantic-ui-react";
import ManualEntryRecordsListRow from "./ManualEntryRecordsListRow";

export class ManualEntryRecordsTable extends React.Component {

    static propTypes = {
        ManualEntryBillingRecords: PropTypes.array,
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox disabled />
            </Table.Header>,
            <Table.Header key="edit-delete"> </Table.Header>,
            <Table.Header key="organization">Organization</Table.Header>,
            <Table.Header key="item-description">Item Description</Table.Header>,
            <Table.Header key="tenant">Tenant</Table.Header>,
            <Table.Header key="country-code">Country</Table.Header>,
            <Table.Header key="billing-type">Billing Type</Table.Header>,
            <Table.Header key="billing-product">Billing Product</Table.Header>,
            <Table.Header key="item-quantity">Item Quantity</Table.Header>,
            <Table.Header key="item-unit-price">Item Unit Price</Table.Header>,
            <Table.Header key="item-total">Item Total</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        return this.props.ManualEntryBillingRecords.map((record, idx) => {
            return <ManualEntryRecordsListRow
                key={idx}
                billingRecord={record}
                organization={record.organization}
                tenant={record.tenant}
                countryCode={record.country_code}
                pricingScheme={record.pricing_scheme}
                billingType={record.billing_type}
                billingProduct={record.billing_product}
                billingPeriod={record.billing_period}
                itemDescription={record.item_description}
                itemQuantity={record.item_quantity}
                itemUnitPrice={record.item_unit_price}
                itemTotal={record.item_total}
            />
        });
    }

    render() {
        return (
            <div className={"records-sticky-table-container"}>
                <Table
                    className={"records-sticky-table"}
                    headers={this.tableHeaders}
                >
                    {this.tableItems}
                </Table>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = dispatch => ({

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ManualEntryRecordsTable)
